import React, { createContext, useContext, useState, useMemo } from "react";
import { siteDummyData } from "../Data/SiteData";

const SiteContext = createContext({});

export const SiteProvider = ({ children }) => {
  const [selectedOrgId,  setSelectedOrgIdRaw]  = useState("all");
  const [selectedSiteId, setSelectedSiteId] = useState("all");

  // Changing org resets site selection
  const setSelectedOrgId = (orgId) => {
    setSelectedOrgIdRaw(orgId);
    setSelectedSiteId("all");
  };

  const selectedOrg = useMemo(
    () => selectedOrgId === "all"
      ? null
      : siteDummyData.organizations.find(o => o.id === selectedOrgId),
    [selectedOrgId]
  );

  const selectedSite = useMemo(
    () => selectedSiteId === "all"
      ? null
      : siteDummyData.sites.find(s => s.id === selectedSiteId),
    [selectedSiteId]
  );

  // Sites visible under the selected org (or all if "all")
  const visibleSites = useMemo(() => {
    if (selectedOrgId === "all") return siteDummyData.sites;
    return siteDummyData.sites.filter(s => s.orgId === selectedOrgId);
  }, [selectedOrgId]);

  return (
    <SiteContext.Provider value={{
      selectedOrgId,  setSelectedOrgId,
      selectedSiteId, setSelectedSiteId,
      selectedOrg,    selectedSite,
      visibleSites,
      organizations: siteDummyData.organizations,
      allSites:      siteDummyData.sites,
    }}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSite = () => useContext(SiteContext);

export default SiteContext;
